import React from "react";

import "./style.scss";

interface Props {
    desktop?: boolean;
}

export const Login = ({ desktop }: Props) => {
    return (
        <div className="loginBox" id="login">
            {/* <a
                className="mobileButton"
                href="https://login.t-online.de/?returnToUrl=https://email.t-online.de/em/index"
                target="_blank"
                rel="noopener noreferrer"
            ></a> */}
            {desktop && (
                <iframe
                    src="https://www.t-online.de/-/id_62530634/tid_tsr_iframe_loginbox/index"
                    scrolling="no"
                    className="TlgnBoxIfr"
                    width="240"
                    height="32"
                    frameBorder="no"
                />
            )}
        </div>
    );
};
